import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, Renderer2 } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RolesButtonsService } from '../../services/roles-buttons.service';
import { ThemeService } from '../../services/theme.service';
import { MenuComponent } from '../menu/menu.component';
import { NotificationComponent } from '../notification/notification.component';

@Component({
  selector: 'app-navbar',
  imports: [
    CommonModule,
    RouterModule,
    NotificationComponent,
    NotificationComponent,
    FormsModule,
    MenuComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  renderer = inject(Renderer2);
  themeService = inject(ThemeService);

  currentTheme: 'light' | 'dark' = 'light';

  rolesButtonsService = inject(RolesButtonsService);

  menu = [
    {
      name: 'Início',
      icon: 'bi-house-door',
      route: '/dashboard',
      disabled:
        this.rolesButtonsService.isAccessible('menu.crud') === true
          ? false
          : true,
    },
    {
      name: 'Perfil',
      icon: 'bi-person',
      route: '/settings',
      disabled:
        this.rolesButtonsService.isAccessible('menu.crud') === true
          ? false
          : true,
    },
    {
      name: 'Configurações',
      icon: 'bi-gear',
      route: '/settings/roles',
      disabled:
        this.rolesButtonsService.isAccessible('menu.crud') === true
          ? false
          : true,
    },
  ];

  constructor() {}
  ngOnInit(): void {
    this.initialTheme();
  }

  onThemeChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.setTheme(value as 'light' | 'dark');
  }

  setTheme(theme: 'light' | 'dark') {
    this.themeService.theme.next(theme);
  }

  private initialTheme() {
    const storedTheme = localStorage.getItem('theme');
    this.currentTheme = storedTheme === 'dark' ? 'dark' : 'light';
    this.setTheme(this.currentTheme);
  }
}
